import React from 'react'

export const GameStateContext = React.createContext(null)